import { isCanceledOrAbortedRequest } from "utils/api-errors";
import { isRetryableNetworkError } from "utils/network-errors";

/**
 * Chrome extension bug (eppiocemhmnlbhjplcgkofciiegomcon) — ignore to save Rollbar quota.
 * @see https://app.rollbar.com/a/minervaproject/fix/item/Monarch/21462#detail
 */
function isChromeExtensionMIdError(error: unknown): boolean {
  const message = "Cannot read properties of undefined (reading 'M_ID')";
  if (error instanceof Error) {
    return error.message === message && Boolean(error.stack?.includes("chrome-extension://"));
  }
  return typeof error === "string" && error === message;
}

/** Returns true for errors that should not be sent to Rollbar via checkIgnore. */
export function isIgnorableRollbarError(error: unknown): boolean {
  return (
    isCanceledOrAbortedRequest(error) ||
    isRetryableNetworkError(error) ||
    isChromeExtensionMIdError(error)
  );
}
